import type React from 'react';

const Incarnate: React.FC = () => null;

export default Incarnate;
